import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.office365EmailLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.Office365Email_Label),
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.Office365Email_Label)
    ]
})
export class Office365EmailLinkedService extends LinkedService { }
